/** @jsx jsx */
import React from 'react'
import { css, jsx } from '@emotion/react'
import Layout from '../components/Layout'
import ThemeWrapper from '../components/Theme'
import { Column, ColumnWrap, ColumnWrapper, Text, Title, Image, Subtitle } from '@swp/components'
import SiteHeader from '../components/SiteHeader'

export default function Page(props) {
  return (
    <ThemeWrapper>
      <Layout title={"pl"}>
        <SiteHeader />

        <Column className="css-l1y9zg" name={"uvod"} style={{"paddingTop":65,"paddingBottom":532}} css={css`
      
    background-image: url(https://cdn.swbpg.com/t/30976/2af87f1f6d5a46e19296fa4a22472e5e_s=350x_.jpg);
    @media (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/30976/2af87f1f6d5a46e19296fa4a22472e5e_s=660x_.jpg);
    }
    @media (min-width: 661px) {
      background-image: url(https://cdn.swbpg.com/t/30976/2af87f1f6d5a46e19296fa4a22472e5e_s=860x_.jpg);
    }
    @media (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/30976/2af87f1f6d5a46e19296fa4a22472e5e_s=1400x_.jpg);
    }
    @media (min-width: 1401px) {
      background-image: url(https://cdn.swbpg.com/t/30976/2af87f1f6d5a46e19296fa4a22472e5e_s=2000x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: url(https://cdn.swbpg.com/t/30976/2af87f1f6d5a46e19296fa4a22472e5e_s=660x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/30976/2af87f1f6d5a46e19296fa4a22472e5e_s=1400x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/30976/2af87f1f6d5a46e19296fa4a22472e5e_s=3000x_.jpg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex el--1" columns={"1"}>
          </ColumnWrap>

        </Column>


        <Column className="pb--60" name={"m00g605y4b"} style={{"paddingTop":47}}>
          
          <ColumnWrap className="column__flex el--1" columns={"1"}>
            
            <ColumnWrapper style={{"maxWidth":800}}>
              
              <Text className="text-box" content={"Przyjdź pracować z nami"}>
              </Text>

              <Title className="title-box title-box--style2" style={{"marginTop":9}} content={"Kariera\n"}>
              </Title>

            </ColumnWrapper>

          </ColumnWrap>

          <ColumnWrap className="column__flex --center el--2" style={{"marginTop":67}} columns={"2"}>
            
            <ColumnWrapper className="js-anim  --anim2 --shadow4 --left pb--50 pl--20 pr--20 pt--25" anim={"2"} style={{"maxWidth":""}}>
              
              <Image className="--left" alt={"Ikonka"} src={"https://cdn.swbpg.com/o/g/Ikonky/Kontakt/3393397d01674c7f9d1e183243e68c8f.svg"} sizes={"100vw"} style={{"maxWidth":80}} srcSet={""} svgColor={"rgba(65,117,5,1)"}>
              </Image>

              <Subtitle className="subtitle-box subtitle-box--style2 w--600" style={{"marginTop":14}} content={"Cieśla w produkcji"}>
              </Subtitle>

              <Text className="text-box w--700 lh--16" style={{"maxWidth":""}} content={"Stolarnia Šimčák to rodzinna firma z 33-letnią tradycją, naciskiem na jakość i rodzinna atmosfera w Malenovicích pod Lysou horou.\n"}>
              </Text>

              <Text className="text-box w--700 lh--16" style={{"marginTop":52}} content={"Kogo szukamy do naszego zespołu?\n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--12" content={"Do naszego rosnącego zespołu szukamy doświadczonych stolarzy / cieśli do produkcji na zamówienie."}>
              </Text>

              <Text className="text-box w--700 lh--16" style={{"marginTop":52}} content={"Co oferujemy?\n\n \n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--12" content={"- Zaplecze rodzinnego biznesu\n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Przyjemne środowisko pracy\n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Pracę z wysokiej jakości narzędziami i nowoczesnymi technologiami \n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Wynagrodzenie finansowe odpowiadające jakości wykonanej pracy\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Nagrody w ciągu roku\n \n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Dodatek na posiłki\n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Premia za dołączenie do firmy \n\n\n\n"}>
              </Text>

              <Text className="text-box w--700 lh--16" style={{"marginTop":52}} content={"Czego wymagamy?\n\n\n\n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--12" content={"- Doświadczenie w branży produkcji mebli \n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Pracowitość, samodzielność, niezawodność i zaangażowanie \n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Chęć do rozwoju"}>
              </Text>

              <Text className="text-box w--700 lh--16" style={{"marginTop":52}} content={"Miejsce pracy:\n\n\n\n\n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--12" content={"Nová Ves 508, Frýdlant nad Ostravicí \n \n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--30" content={"Informacje na:"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"<span style=\"color: var(--color-custom-1);\">info@simcak.net</span>"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"Tel. číslo:  +420 773 622 080\n<br>"}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper className="js-anim  --anim2 --shadow4 --left pb--50 pl--20 pr--20 pt--25" anim={"2"} style={{"maxWidth":""}}>
              
              <Image className="--left" alt={"Ikonka"} src={"https://cdn.swbpg.com/o/g/Ikonky/Kontakt/3393397d01674c7f9d1e183243e68c8f.svg"} sizes={"100vw"} style={{"maxWidth":80}} srcSet={""} svgColor={"rgba(65,117,5,1)"}>
              </Image>

              <Subtitle className="subtitle-box subtitle-box--style2 w--600" style={{"marginTop":14}} content={"Monter w terenie\n \n"}>
              </Subtitle>

              <Text className="text-box w--700 lh--16" style={{"maxWidth":""}} content={"Stolarnia Šimčák to rodzinna firma z 33-letnią tradycją, która kładzie nacisk na jakość i rodzinna atmosfera, z siedzibą w Malenovicích pod Lysou horou.\n"}>
              </Text>

              <Text className="text-box w--700 lh--16" style={{"marginTop":52}} content={"Kogo szukamy do naszego zespołu?\n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--12" content={"Do naszego rosnącego zespołu szukamy doświadczonych monterów do produkcji na zamówienie."}>
              </Text>

              <Text className="text-box w--700 lh--16" style={{"marginTop":52}} content={"Co oferujemy? \n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--12" content={"- Zaplecze rodzinnego biznesu\n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Przyjemne środowisko pracy\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Pracę z wysokiej jakości narzędziami i nowoczesnymi technologiami \n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Wynagrodzenie finansowe odpowiadające jakości wykonanej pracy"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Nagrody w ciągu roku\n \n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Dodatek na posiłki\n\n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Premia za dołączenie do firmy\n \n\n\n\n"}>
              </Text>

              <Text className="text-box w--700 lh--16" style={{"marginTop":52}} content={"Czego wymagamy?\n\n\n\n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--12" content={"- Doświadczenie w montażu mebli, ewentualnie ich produkcji  \n \n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Przyjemny sposób bycia \n \n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Prawo jazdy kategorii B\n \n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Pracowitość, niezawodność i zaangażowanie\n \n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"- Oraz chęć do rozwoju\n \n\n\n\n"}>
              </Text>

              <Text className="text-box w--700 lh--16" style={{"marginTop":52}} content={"Miejsce pracy:\n\n\n\n\n\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--12" content={"Nová Ves 508, Frýdlant nad Ostravicí \n \n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--30" content={"Informacje na:\n\n\n"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"<span style=\"color: var(--color-custom-1);\">info@simcak.net</span>"}>
              </Text>

              <Text className="text-box lh--16 mt--06" content={"Tel. číslo:  +420 773 622 080\n<br>"}>
              </Text>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="pb--60" name={"mf0yn4h9ohk"} style={{"paddingTop":75,"backgroundColor":"#faf8f8"}}>
          
          <ColumnWrap className="column__flex --center el--2" style={{"maxWidth":890}} columns={"2"}>
            
            <ColumnWrapper className="js-anim  --anim5" anim={"5"} style={{"maxWidth":480}}>
              
              <Image alt={"ikonka"} src={"https://cdn.swbpg.com/o/g/Ikonky/Kontakt/6b72aab19c4f4d1ca38a5ca397b2ec1c.svg"} sizes={"100vw"} style={{"maxWidth":90}} srcSet={""} svgColor={"rgba(65,117,5,1)"}>
              </Image>

              <Text className="text-box" style={{"marginTop":10}} content={"Proszę wysyłać CV na:\n"}>
              </Text>

              <Text className="text-box fs--18 w--700 lh--18" style={{"marginTop":10}} content={"info@simcak.net"}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper className="js-anim  --anim4" anim={"4"} style={{"maxWidth":480}}>
              
              <Image alt={"ikonka"} src={"https://cdn.swbpg.com/o/g/Ikonky/Kontakt/965c3e40d27d46d385ed085e1b11d2fa.svg"} sizes={"100vw"} style={{"maxWidth":90}} srcSet={""} svgColor={"rgba(65,117,5,1)"}>
              </Image>

              <Text className="text-box" style={{"marginTop":10}} content={"W przypadku pytań proszę dzwonić na:\n"}>
              </Text>

              <Text className="text-box fs--18 w--700 lh--18" style={{"marginTop":10}} content={"773 622 &nbsp;080"}>
              </Text>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="pb--60" name={"sluzby"} style={{"paddingTop":73}}>
          
          <ColumnWrap className="column__flex --center el--1" columns={"1"}>
            
            <ColumnWrapper className="js-anim  --anim2 --anim-s2" anim={"2"} animS={"2"}>
              
              <Title className="title-box title-box--style2" content={"Dlaczego warto pracować właśnie u nas?\n"}>
              </Title>

              <Text className="text-box" style={{"maxWidth":698}} content={"Pomagamy tworzyć meble i wnętrza, w których ludziom będzie się lepiej pracować i żyć. Ciągle rośniemy i mamy jasny cel: z dobrej firmy zrobić świetną."}>
              </Text>

            </ColumnWrapper>

          </ColumnWrap>

          <ColumnWrap className="column__flex js-anim  --anim2 --anim-s2 --center el--3 mb--10 mt--40 pr--08" anim={"2"} animS={"2"} style={{"maxWidth":1000}} columns={"3"}>
            
            <ColumnWrapper className="js-anim  --anim2" anim={"2"}>
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/o/g/Ikonky/Finance/finanfce-5.svg"} sizes={"100vw"} style={{"maxWidth":96}} srcSet={""} svgColor={"rgba(65,117,5,1)"}>
              </Image>

              <Subtitle className="subtitle-box w--600" content={"Stabilność\n"}>
              </Subtitle>

            </ColumnWrapper>

            <ColumnWrapper className="js-anim  --anim2" anim={"2"}>
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/o/g/Ikonky/Kontakt/ec56f61a8d3f46ea995f227e5056cd0f.svg"} sizes={"100vw"} style={{"maxWidth":96}} srcSet={""} svgColor={"rgba(65,117,5,1)"}>
              </Image>

              <Subtitle className="subtitle-box w--600" content={"Jakość\n"}>
              </Subtitle>

            </ColumnWrapper>

            <ColumnWrapper className="js-anim  --anim2" anim={"2"}>
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/o/g/Ikonky/Finance/finanfce-4.svg"} sizes={"100vw"} style={{"maxWidth":96}} srcSet={""} svgColor={"rgba(65,117,5,1)"}>
              </Image>

              <Subtitle className="subtitle-box w--600" content={"Pewność\n"}>
              </Subtitle>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="pb--08 pt--08" name={"paticka"} style={{"backgroundColor":"rgba(65,117,5,1)"}}>
          
          <ColumnWrap className="column__flex js-anim  --anim2 --anim-s2 el--3" anim={"2"} animS={"2"} style={{"maxWidth":1420}} columns={"3"}>
            
            <ColumnWrapper style={{"maxWidth":""}}>
              
              <Subtitle className="subtitle-box fs--20" content={"<span style=\"color: rgb(255, 255, 255);\">prace.simcak.net</span><br>"}>
              </Subtitle>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>

      </Layout>
    </ThemeWrapper>
  )
}